import { render, staticRenderFns } from "./modalDetalle.vue?vue&type=template&id=4214aa9a&scoped=true&"
import script from "./modalDetalle.vue?vue&type=script&lang=js&"
export * from "./modalDetalle.vue?vue&type=script&lang=js&"
import style0 from "./modalDetalle.vue?vue&type=style&index=0&id=4214aa9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4214aa9a",
  null
  
)

export default component.exports